import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBars, FaShoppingCart, FaTimes } from 'react-icons/fa';
import { navItems, wideStoreLayoutPageIds } from '../catalog';
import { useCart } from '../context/CartContext';

export default function Navbar({ activePage, setActivePage }) {
  const navigate = useNavigate();
  const { cartLineCount } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);

  const goToSection = (pageId) => {
    navigate('/');
    setActivePage(pageId);
    setMenuOpen(false);
  };

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 769px)');
    const onChange = () => {
      if (mq.matches) setMenuOpen(false);
    };
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  const useWideStoreLayout = wideStoreLayoutPageIds.includes(activePage);

  return (
    <header className={`topbar${useWideStoreLayout ? ' topbar--wide-store' : ''}`}>
      <div className="topbar-inner topbar-inner--with-brand">
        <Link to="/" className="nav-brand-link" onClick={() => setActivePage('home')}>
          <span className="nav-brand">Pranavi&apos;s Kitchen</span>
        </Link>


        <nav
          id="primary-nav"
          className={`navbar-menu${menuOpen ? ' navbar-menu--open' : ''}`}
        >
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`nav-btn ${activePage === item.id ? 'active' : ''}`}
              type="button"
              onClick={() => goToSection(item.id)}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <Link to="/cart" className="cart-icon-link" aria-label="View cart">
          <span className="cart-icon-wrap">
            <FaShoppingCart className="cart-icon-svg" aria-hidden />
            {cartLineCount > 0 ? (
              <span className="cart-badge cart-badge-icon">{cartLineCount}</span>
            ) : null}
          </span>
        </Link>

        <button
          type="button"
          className={`nav-menu-toggle${menuOpen ? ' nav-menu-toggle--open' : ''}`}
          onClick={() => setMenuOpen((o) => !o)}
          aria-expanded={menuOpen}
          aria-controls="primary-nav"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        >
          {menuOpen ? <FaTimes className="nav-menu-toggle-icon" aria-hidden /> : <FaBars className="nav-menu-toggle-icon" aria-hidden />}
        </button>
      </div>
    </header>
  );
}